'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobCountyZip } from '../../Entities/Glob/GlobCountyZip';
import { GlobCountyZipCollection } from '../../Collections/Glob/GlobCountyZipCollection';

export class GlobCountyZipRepository extends CoreRepository {
  public getGlobCountyZips(options: object = {}) {
    if (!options) {
      options = {};
    }
    return this.webAPI.getGlobCountyZips(options).then((response) => {
      const collection = new GlobCountyZipCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobCountyZip();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
